import React from "react";
interface MetricsData {
  totalActiveSupplier: number;
  totalInactiveSupplier: number;
  totalSupplier: number;
  totalSupplierPendingApproval: number;
}

interface MetricsProps {
  metrics: MetricsData;
}
const StatisticsCard: React.FC<MetricsProps> = ({ metrics }) => {
  return (
    <div className="my-7">
      <div className="flex lg:grid lg:grid-cols-4 gap-4 overflow-x-auto scrollbar-hide lg:overflow-visible whitespace-nowrap">
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Total Suppliers
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {metrics?.totalSupplier || 0}
          </h1>
        </section>

        {/* Orders Card */}
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Pending Approval
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {metrics?.totalSupplierPendingApproval || 0}
          </h1>
        </section>

        {/* Withdrawals Card */}
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Active Suppliers
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {" "}
            {metrics?.totalActiveSupplier || 0}
          </h1>
        </section>
        {/* Out Escrow Card */}

        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Suspended Suppliers
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {metrics?.totalInactiveSupplier|| 0}
          </h1>
        </section>
      </div>
    </div>
  );
};

export default StatisticsCard;
